import React, { useEffect, useRef, useState } from "react"
import { Input, Progress, Button, Col, FormFeedback, Row } from "reactstrap"
import "flatpickr/dist/themes/material_blue.css"
import toast from "react-hot-toast"
import { APICore } from "helpers/api/apiCore"
import { useLogout } from "hooks/useLogout"
import UploadFile from "../../assets/images/icons/upload-file.svg"
import SignatureImg from "../../assets/images/signature-img.png"
import closeIcon from "../../assets/images/icons/close.svg"
import Spinners from "components/Common/Spinner"
import KYCPrevButton from "./kycPrevButton"
import UploadedFileBox from "./uploadedFileBox"
import { urlToFile } from "helpers/common"

const api = new APICore()

const BankUploadAndFetch = ({
  fieldKey,
  validation,
  setCheque,
  setOldCheque,
  isLoading,
  extensionAllowedInput,
  setShowBankDetails,
  extensionAllowed,
  kycData,
}) => {
  const [file, setFile] = useState(null)
  const [progress, setProgress] = useState(0)
  const [isUploading, setIsUploading] = useState(false)
  const fileRef = useRef(null)
  const logout = useLogout()

  const onUploadFile = async (file) => {
    try {
      setIsUploading(false)
      if (!file) {
        toast.error("Please select file.", {
          id: "toasterMessage",
        })
        return
      }
      if (!extensionAllowed.includes(file.type)) {
        toast.error("Please upload files in JPG, PNG, or PDF format only.", {
          id: "toasterMessage",
        })
        return
      }

      const maxSize = 10 * 1024 * 1024
      if (file.size > maxSize) {
        toast.error("You can upload a maximum 10MB image", {
          id: "toasterMessage",
        })
        return
      }
      const { data } = await api.uploadFile(
        "/common/file",
        {
          file,
        },
        (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          setProgress(progress)
        }
      )

      setCheque(data.data.filename)
    } catch (error) {
      if (error.status === 401) {
        logout()
      }
      toast.error(error?.response?.data?.message, { id: "toasterMessage" })
    } finally {
      setIsUploading(false)
    }
  }

  useEffect(() => {
    if (kycData) {
      convertUrlToFile(
        kycData?.investorsBankDetails?.cheque_file,
        kycData?.investorsBankDetails?.cheque_file_url
      )
    }
  }, [fieldKey, kycData])

  const convertUrlToFile = async (name, file) => {
    try {
      const fileObject = await urlToFile(file, name)
      setFile(fileObject)
      setOldCheque(true)
    } catch (error) {}
  }

  return (
    <React.Fragment>
      <div
        className={`upload-file-input ${
          validation.errors[fieldKey] && "is-invalid"
        }`}
        style={{
          cursor: "pointer",
        }}
        onClick={() => fileRef?.current?.click()}
      >
        <Input
          name={fieldKey}
          type="file"
          innerRef={fileRef}
          className="form-control d-none"
          placeholder="No file chosen"
          accept={extensionAllowedInput}
          onChange={(e) => {
            const file = e.target.files[0]
            if (file) {
              onUploadFile(file)
              setFile(file)
              setOldCheque(false)
            }
          }}
        />

        <Input
          name=""
          type="text"
          className="form-control cp"
          id="horizontal-firstname-Input"
          placeholder="Upload your signature"
          value={file ? file.name : "No file chosen"}
          readOnly
        />
        <img src={UploadFile} alt="" />
      </div>

      {validation.errors.file && validation.touched.file ? (
        <FormFeedback type="invalid">{validation.errors.file}</FormFeedback>
      ) : null}

      {progress > 0 && progress < 100 && (
        <Progress
          className="w-100"
          value={progress}
          style={{
            height: "3px",
          }}
        />
      )}
      <Col xl={12}>
        <span className="floating-labels">
          File format: jpeg, png | File size: Upto 10mb
        </span>
      </Col>

      {file && (
        <UploadedFileBox
          label={"Cancelled Cheque"}
          href={URL.createObjectURL(file)}
        />
      )}

      <Col sm={12}>
        <Row className="mt-4">
          <KYCPrevButton
            kycData={kycData}
            disabled={isUploading}
            ButtonHtml={
              <button
                type="button"
                className="btn btn-primary w-100"
                disabled={isUploading || isLoading}
                onClick={() => setShowBankDetails(file ? false : true)}
              >
                {isUploading || isLoading ? <Spinners /> : "Save & Next"}
              </button>
            }
          />
        </Row>
      </Col>
    </React.Fragment>
  )
}

export default BankUploadAndFetch
